import React, { useEffect, useState } from 'react';
import { Layout as AntdLayout, Button, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { NavLink } from 'react-router-dom';
import Menu from './Menu';
import ReduxRedirect from '../Common/ReduxRedirect';

import styles from './index.module.scss';
import HeaderContent from '../Common/Header';
import FooterContent from '../Common/Footer';
import { ProductProvider } from '../../context/products';
import { ArticleProvider } from '../Common/Header/context';

const { Header, Sider, Content } = AntdLayout;

interface LayoutProps {
  LeftMenu?: React.FC;
  leftMenu?: React.ReactNode;
  transparent?: boolean;
  disableLeftMenu?: boolean;
  children: React.ReactNode;
  collapsedByDefault?: boolean;
  minWidth?: boolean;
}

let defaultStateCollapsed = false;

function Layout({
  disableLeftMenu = false,
  LeftMenu,
  leftMenu,
  transparent,
  children,
  collapsedByDefault = false,
  minWidth,
}: LayoutProps): React.ReactNode {
  const [collapsed, setCollapsed] = useState(defaultStateCollapsed);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const isTablet = useMediaQuery({
    query: '(max-width: 1024px)',
  });
  const disableMenu = disableLeftMenu || (!LeftMenu && !leftMenu);

  useEffect(() => {
    defaultStateCollapsed = collapsed;
  }, [collapsed]);

  useEffect(() => {
    if ((isTablet && !disableMenu) || collapsedByDefault) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isTablet, disableMenu]);

  return (
    <>
      <ReduxRedirect />
      <AntdLayout hasSider className={styles.layout}>
        <AntdLayout className={clsx(styles.wrapper, { [styles.tablet]: isTablet && !disableMenu })}>
          <HeaderContent />
          <div className={clsx(styles.scroll, { [styles.collapsed]: collapsed })}>
            <Content
              className={clsx(
                styles.content,
                { [styles.transparent]: transparent },
                { [styles.minWidth]: isTablet && minWidth },
              )}
              id="layout-content"
            >
              {children}
            </Content>
            <FooterContent />
          </div>
        </AntdLayout>
      </AntdLayout>
    </>
  );
}

export default Layout;
